export enum AuthProviderId {
    PASSWORD = "password",
    GOOGLE_SIGN_ON = "google-sign-on"
}